import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'CCI' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'CCI', label: 'Commodity Channel Index', pane: 'sub', params: [20], outputs: ['cci'], labels: ['Length'] })
